import classNames from 'classnames';
import store from 'store';
import { useLocation } from 'react-router-dom';

import styles from './BaseFooter.module.scss';
import { IBaseFooterProps } from './interface';

// Helpers

import { config } from '../../../utils/config';
import { useWindowSize } from '../../../utils/hooks/windowSize';

// Assets
import { IqosIcon } from '../../../assets/icons/IqosIcon';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

// Components
import FooterMobileMenu from './FooterMobileMenu';
import DesktopMenu from './DesktopMenu';
import Button from '../Button';

const BaseFooter = (props: IBaseFooterProps) => {
    const { className, internalLayout, forceDesktop, isStardrift, isFullWidth } = props;

    const windowSize = useWindowSize();
    const isMobile = (windowSize.width ?? 0) < 870;
    const isBigDesktop = (windowSize.width ?? 0) > 1300;

    const isLoggedIn = store.get(config.user.authToken);
    const location = useLocation();

    const addSpaceToBottom = !isLoggedIn && location.pathname === '/';

    return (
        <footer
            className={classNames(
                styles.footer,
                isStardrift && styles.stardriftFooter,
                addSpaceToBottom && styles.addSpaceToFooter,
                className && className
            )}
        >
            <section className="container">
                {isMobile ? (
                    <FooterMobileMenu />
                ) : isLoggedIn && !forceDesktop ? (
                    <FooterMobileMenu />
                ) : (
                    <DesktopMenu />
                )}
            </section>

            <section
                className={classNames(
                    styles.legalDisclaimer,
                    isFullWidth && styles.maxWidthContainer
                )}
            >
                <section
                    className={classNames(
                        internalLayout ? styles.containerInternalLayout : 'container'
                    )}
                >
                    <section
                        className={classNames(
                            internalLayout ? styles.wrapperInternalLayout : styles.wrapper
                        )}
                    >
                        <div
                            className={classNames(
                                internalLayout ? styles.logoInternalLayout : styles.logo
                            )}
                        >
                            <IqosIcon />
                        </div>

                        <p
                            className={classNames(
                                internalLayout && styles.descriptionInternalLayout
                            )}
                        >
                            Aceste produse nu sunt lipsite de riscuri. Eliberează nicotină, care
                            provoacă dependență. IQOS și lil SOLID sunt destinate adulților care
                            altfel ar continua să fumeze sau să folosească produse cu nicotină.
                        </p>
                    </section>

                    {isMobile && (
                        <section className={styles.philipMorrisInfo}>
                            PHILIP MORRIS TRADING S.R.L. <br /> C.U.I. RO4888165, Reg. Com.
                            J23/511/2004 <br />
                            Sediu Social: Strada Horia, Cloşca şi Crişan nr. 83 - 105, <br />{' '}
                            Otopeni, Clădirea A, jud. llfov, România <br /> Punct de lucru: Str.
                            Nicolae Filipescu, nr. 28, Sector 2, București <br /> © 2024 Philip
                            Morris Products S.A.
                        </section>
                    )}

                    <section
                        className={classNames(
                            internalLayout ? styles.socialsInternalLayout : styles.socials
                        )}
                    >
                        <Button
                            label=""
                            type="text"
                            target="_blank"
                            ariaLabel="facebook"
                            icon={<FaFacebookF />}
                            href={config.path.socialMedia.facebook}
                        />

                        <Button
                            label=""
                            type="text"
                            target="_blank"
                            ariaLabel="youtube"
                            icon={<FaYoutube />}
                            href={config.path.socialMedia.youtube}
                        />

                        <Button
                            label=""
                            type="text"
                            target="_blank"
                            ariaLabel="instagram"
                            icon={<FaInstagram />}
                            href={config.path.socialMedia.instagram}
                        />
                    </section>
                </section>

                {isBigDesktop && isFullWidth && !isMobile && (
                    <section className={styles.philipMorrisInfoBigDesktop}>
                        <div className={styles.leftSide}>
                            <p>PHILIP MORRIS TRADING S.R.L.</p>

                            <p>C.U.I. RO4888165, Reg. Com. J23/511/2004</p>

                            <p>
                                Sediu Social: Strada Horia, Cloşca şi Crişan nr. 83 - 105, Otopeni,
                                Clădirea A, jud. llfov, România Punct de lucru: Str. Nicolae
                                Filipescu, nr. 28, Sector 2, București
                            </p>
                        </div>

                        <div className={styles.rightSide}>
                            <p>© 2024 Philip Morris Products S.A.</p>
                        </div>
                    </section>
                )}

                {isFullWidth && isBigDesktop
                    ? null
                    : !isMobile && (
                          <section className={styles.philipMorrisInfoDesktop}>
                              PHILIP MORRIS TRADING S.R.L. <br /> C.U.I. RO4888165, Reg. Com.
                              J23/511/2004 <br />
                              Sediu Social: Strada Horia, Cloşca şi Crişan nr. 83 - 105, Otopeni,
                              Clădirea A, jud. llfov, România <br /> Punct de lucru: Str. Nicolae
                              Filipescu, nr. 28, Sector 2, București <br /> © 2024 Philip Morris
                              Products S.A.
                          </section>
                      )}
            </section>
        </footer>
    );
};

export default BaseFooter;
